"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _merchant = require("@/api/merchant");
var _default = {
  props: ['id'],
  data: function data() {
    return {
      loading: false,
      selectLoading: false,
      infoData: {
        id: 0,
        score_reward: 0
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;
      this.loading = true;
      (0, _merchant.getMerchantInfo)(this.sMerchantId).then(function (res) {
        _this.loading = false;
        if (res) {
          for (var key in _this.infoData) {
            _this.infoData[key] = res[key];
          }
        }
      });
    },
    submit: function submit() {
      var _this2 = this;
      console.log('submit', this.infoData);
      var param = (0, _objectSpread2.default)({}, this.infoData);
      (0, _merchant.editMerchantInfo)(param).then(function (res) {
        _this2.getData();
      });
    }
  }
};
exports.default = _default;